import React from "react";
import { useSelector } from "react-redux";
import LabelAndValue from "./LabelAndValue";
import { formatDateTimeWithToday } from "../../../../Utils/formatDate";

const RequestDetails = () => {
  const { activeBatterySosRequest } = useSelector((state) => state.trips);

  if (!activeBatterySosRequest) return null;

  const request = activeBatterySosRequest;

  const formattedTime = formatDateTimeWithToday(request.createdAt);

  return (
    <div
      className="
        rounded-xl
        border
        border-yellow
        bg-yellow-10
        px-6
        py-4
      "
    >
      <div className="flex justify-between items-start ">
        <div className="bg-yellow px-2 py-1 rounded-md">
          <span className="font-poppins leading-none text-xs font-medium text-black">
            Battery Swap
          </span>
        </div>

        <p className="font-poppins font-normal text-xs text-dark-gray leading-none mt-1">
          {formattedTime}
        </p>
      </div>

      <div className="mt-5 flex items-center gap-x-4">
        <LabelAndValue label="Driver" value={request.driverName || "Driver"} />

        <LabelAndValue
          label="Contact No."
          value={request.driverContact || "--"}
        />
      </div>

      <div className="mt-6 flex items-center gap-x-4">
        {request.tripId ? (
          <LabelAndValue label="Trip ID" value={request.tripId || "--"} />
        ) : (
          request.rentalId && (
            <LabelAndValue label="Rental ID" value={request.rentalId || "--"} />
          )
        )}

        <LabelAndValue label="Driver Hub Station" value={request.hubName} />
      </div>

      <div className="mt-6 flex items-center gap-x-4">
        <LabelAndValue label="Driver Location" value={request.driverLocation} />
      </div>

      <div className="flex flex-col mt-4">
        <div className="flex gap-2 flex-wrap">
          {request.photos?.map((photo, index) => (
            <img
              key={photo}
              src={photo}
              alt={`depleted-battery-${index}`}
              className="w-20 h-20 object-cover rounded-lg border border-light-grey"
              onError={(e) => {
                e.target.src = "/images/battery-image.png";
              }}
            />
          ))}
          {(!request.photos || request.photos.length === 0) && (
            <span className="text-xs text-grey-500">No photos uploaded</span>
          )}
        </div>
        <span className="font-poppins font-normal text-xs text-dark-gray mt-2">
          Photos
        </span>
      </div>
    </div>
  );
};

export default RequestDetails;
